import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { adaptPresentationToRequest } from "pages/TiVoApps/AppForm/utils";

type UpdateProviderPresentationsPayload = {
  presentations: ReturnType<typeof adaptPresentationToRequest>[];
  id: string;
  isCreateMode?: boolean;
};

export const useUpdateProviderPresentations = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<void, Error, UpdateProviderPresentationsPayload>({
    mutationFn: async ({ presentations, id, isCreateMode = false }) => {
      try {
        return await dispatch(
          apiThatThrows.updateTiVoProviderPresentation.action({
            params: { id },
            options: {
              body: JSON.stringify({ data: presentations }),
            },
          })
        );
      } catch (error) {
        // If an error occurs in create mode,
        // delete the provider so that we can resubmit the create provider request.
        if (isCreateMode) {
          await dispatch(
            apiThatThrows.deleteTiVoProvider.action({
              params: { id },
            })
          );
        }
        throw error;
      }
    },
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ["provider", id] });
    },
  });
};
